/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>修改密码</el-breadcrumb-item>
    </el-breadcrumb>



      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="原密码" prop="pass">
          <el-input size="small" v-model="editForm.pass" auto-complete="off" placeholder="请输入原密码"  type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newpass">
          <el-input size="small" v-model="editForm.newpass" auto-complete="off" placeholder="请输入新密码"  type="password"></el-input>
        </el-form-item>

        <el-form-item label="重复新密码" prop="checknewpass">
          <el-input size="small" v-model="editForm.checknewpass" auto-complete="off" placeholder="请再次输入新密码"  type="password"></el-input>
        </el-form-item>

    </el-form>
    <div class="grid-content bg-purple">
      <el-button type="primary"  @click="resetpwd('editForm')">保存</el-button>
    </div>



  </div>
</template>

<script>
// 导入请求方法
import {
    userPwd

} from '../../api/userMG'


export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.editForm.newpass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      editForm: {
        pass: '',
        newpass: '',
        checknewpass: ''

      },
      rules: {
        pass: [{required: true, message: "请输入密码"}],
        newpass: [{required: true, message: "请输入新密码"}],
        checknewpass: [{required: true, validator: validatePass2, trigger: "blur"}]
      }
    }
  },



  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 重置密码
    resetpwd(editData) {
      console.log("111111111111111111111");
      this.$refs[editData].validate(valid => {
        console.log("222222222222222222222222222");
        if (valid) {
          this.$confirm('确定要重置密码吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              userPwd(this.editForm)
                .then(res => {
                  if (res.code==0) {
                    this.$message({
                      type: 'success',
                      message: '重置密码成功！'
                    })
                    this.getdata(this.formInline)
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
                .catch(err => {
                  this.loading = false

                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消重置密码！'
              })
            })
        }
        })


    },



  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/modpass.vue